import React, { useState } from "react";
import Select from "react-select";

const SelectComponent = ({
  borderRadius,
  options,
  css,
  value = "",
  name,
  placeholder,
  height,
  handleChange,
}) => {
  const [selectedValue, setSelectedValue] = useState(
    options?.find((item) => item?.value === value) || null
  );

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: height ? height : "30px",
      padding: "0px",
      textAlign: "left !important",
      borderRadius: borderRadius ? borderRadius : "5px 0px 0px 5px",
      borderColor: state.isFocused ? "black" : provided.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px black" : provided.boxShadow,
      "&:hover": { borderColor: "black" },
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      border: "none !important",
      padding: "2px",
      margin: "3px",
      width: "20px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "4px",
      border: "none",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "190px", // 👈 Limit dropdown height
      overflowY: "auto", // 👈 Scroll if needed
    }),
  };

  return (
    <div className={css}>
      <Select
        options={options}
        value={selectedValue}
        onChange={(selectedOption) => {
          setSelectedValue(selectedOption);
          handleChange(name, selectedOption?.value);
        }}
        name={name}
        placeholder={placeholder || ""}
        styles={customStyles}
        className="focus:outline-black text-left outline-black outline-1"
      />
    </div>
  );
};

export default SelectComponent;
